import React, { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import { getFirestore, collection, query, where, getDocs } from "firebase/firestore";
import "./viewabstraction.css";

function ViewAbstraction() {
  // const [abstractData, setAbstractData] = useState(null);
  // const [loading, setLoading] = useState(true);
  // const auth = getAuth();
  // const db = getFirestore();

  // useEffect(() => {
  //   const fetchAbstract = async () => {
  //     if (!auth.currentUser) {
  //       setLoading(false);
  //       return;
  //     }

  //     const userEmail = auth.currentUser.email;
  //     const abstractsRef = collection(db, "abstracts");
  //     const q = query(abstractsRef, where("email", "==", userEmail));

  //     try {
  //       const querySnapshot = await getDocs(q);
  //       if (!querySnapshot.empty) {
  //         const data = querySnapshot.docs[0].data(); // Assuming only one abstract per user
  //         setAbstractData(data);
  //       } else {
  //         setAbstractData(null);
  //       }
  //     } catch (error) {
  //       console.error("Error fetching abstract:", error);
  //     }
  //     setLoading(false);
  //   };

  //   fetchAbstract();
  // }, [auth]);

   const [abstractData, setAbstractData] = useState(null);
  const [loading, setLoading] = useState(true);
  const auth = getAuth();
  const db = getFirestore();

  useEffect(() => {
    const fetchAbstract = async () => {
      if (!auth.currentUser) {
        setLoading(false);
        return;
      }

      const userEmail = auth.currentUser.email;
      const abstractsRef = collection(db, "abstracts");
      const q = query(abstractsRef, where("email", "==", userEmail));

      try {
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
          // Get the most recent abstract if user has multiple submissions
          const docs = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          const sorted = docs.sort((a, b) => b.createdAt?.toDate() - a.createdAt?.toDate());
          setAbstractData(sorted[0]);
        } else {
          setAbstractData(null);
        }
      } catch (error) {
        console.error("Error fetching abstract:", error);
      }
      setLoading(false);
    };

    fetchAbstract();
  }, [auth, db]);

  const getStatusMessage = () => {
    if (!abstractData) return "";
    
    switch(abstractData.status) {
      case "approved":
        return "Congratulations! Your abstract has been accepted for presentation.";
      case "rejected":
        return "Thank you for your submission. Unfortunately, your abstract wasn't selected this time.";
      default:
        return "Your abstract is currently under review. Please check back later for updates.";
    }
  };




  return (


  <>
      <section className="hero">
        <div className="hero-image">
          <img src="/eye care 2027 profile image.png" alt="conference" />
        </div>
        <div className="hero-content">
          <h1>Abstract Status</h1>
          <p>Check the review status of your submitted abstract</p>
        </div>
      </section>

      <div className="abstract-status-container">
        {loading ? (
          <div className="loading-spinner">Loading...</div>
        ) : abstractData ? (
          <div className="abstract-status-card">
            <div className="status-header">
              <h2>Your Abstract Submission</h2>
              <div className={`status-badge ${abstractData.status || 'pending'}`}>
                {abstractData.status || 'pending'}
              </div>
            </div>
            
            <div className="status-message">
              <p>{getStatusMessage()}</p>
            </div>

            <div className="abstract-details">
              <h3>Submission Details</h3>
              <div className="detail-row">
                <span className="detail-label">Title:</span>
                <span className="detail-value">{abstractData.title}</span>
              </div>
              <div className="detail-row">
                <span className="detail-label">Submitted on:</span>
                <span className="detail-value">
                  {abstractData.createdAt?.toDate().toLocaleDateString() || "Date not available"}
                </span>
              </div>
              
              <h3>Abstract Content</h3>
              <div className="abstract-content">
                {abstractData.abstract}
              </div>

              {abstractData.fileUrl && (
                <div className="file-download">
                  <a href={abstractData.fileUrl} target="_blank" rel="noopener noreferrer">
                    <button className="download-btn">
                      📄 Download Submitted File
                    </button>
                  </a>
                </div>
              )}

              {abstractData.status === "approved" && (
                <div className="next-steps">
                  <h3>Next Steps</h3>
                  <p>Please prepare your presentation according to the conference guidelines.</p>
                  <p>Presentation schedule will be communicated soon.</p>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="no-abstract">
            <h2>No Abstract Submission Found</h2>
  
          </div>
        )}
      </div>
    </>
  );
}

export default ViewAbstraction;

